// ============================================================
// Cart button icon
// ============================================================
document.addEventListener('DOMContentLoaded', function() {
  var btn = document.getElementById('product-add-to-cart');
  if (btn) {
    btn.innerHTML = '🛒 ' + btn.innerHTML;
  }
});

// ============================================================
// Mobile menu colors (nav-menu-tab only, NOT halo-sidebar-wrapper)
// ============================================================
function fixMobileMenuColors() {
  var fg = '#F8FAD3';

  var tabs = document.querySelectorAll('.site-nav-mobile.nav-menu-tab');
  tabs.forEach(function(el) {
    el.style.setProperty('background-color', '#FE5586', 'important');
    el.style.setProperty('color', fg, 'important');
  });

  tabs.forEach(function(el) {
    el.querySelectorAll('a, span, button').forEach(function(child) {
      child.style.setProperty('color', fg, 'important');
    });
    el.querySelectorAll('svg, svg path').forEach(function(child) {
      child.style.setProperty('fill', fg, 'important');
      child.style.setProperty('stroke', fg, 'important');
    });
  });
}

document.addEventListener('DOMContentLoaded', fixMobileMenuColors);
document.addEventListener('click', function() {
  setTimeout(fixMobileMenuColors, 150);
});

// ============================================================
// Fix filter sidebar background
// ============================================================
(function() {
function fixSidebar() {
  var wrapper = document.querySelector('#halo-sidebar .halo-sidebar-wrapper');
  var header = document.querySelector('#halo-sidebar .halo-sidebar-header');
  if (!wrapper) return;

  var isArticle = document.body.classList.contains('template-article');
  var isCollection = document.body.classList.contains('template-collection');
  var bgColor = (isArticle || isCollection) ? '#FCF0F5' : '#F6F8FC';

  wrapper.style.setProperty('background-color', bgColor, 'important');
  if (header) header.style.setProperty('background-color', bgColor, 'important');

  var observer = new MutationObserver(function() {
    wrapper.style.setProperty('background-color', bgColor, 'important');
    if (header) header.style.setProperty('background-color', bgColor, 'important');
  });
  observer.observe(wrapper, { attributes: true, attributeFilter: ['style'] });
}
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSidebar);
  } else {
    fixSidebar();
  }
})();